(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('HospitalizationDischargeToSearch', HospitalizationDischargeToSearch);

    HospitalizationDischargeToSearch.$inject = ['$resource'];

    function HospitalizationDischargeToSearch($resource) {
        var resourceUrl =  'api/_search/hospitalization-discharge-tos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
